import { SellerShops } from 'components/sellers/SellerShops/SellerShops'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileShops: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerShops type='profile' sellerId={sellerId ?? ''} />
}
